import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Chip,
} from "@mui/material";
import moment from "moment";
import { GradientButtonOutline } from "components/GradientButton";
import TableModal from "components/TableExplanded/TableModal";

const categoryOptions = [
  { label: "Category 1", id: 1 },
  { label: "Category 2", id: 2 },
  { label: "Category 3", id: 3 },
];

const customersFields = [
  { label: "เลขบัตรประชาชน", name: "idcard" },
  { label: "ชื่อ-สกุล", name: "customer_name" },
  { label: "ที่อยู่", name: "address" },
  { label: "เบอร์โทร", name: "phonenumber" },
];

const ModalView = ({ open, onClose, viewProduct }) => {
  const [initialProductUrls, setInitialProductUrls] = useState([]);
  const [dataUseForTable, setDataUseForTable] = useState([]);

  const getOrderStatus = (status) => {
    switch (status) {
      case 1:
        return { label: "ขายฝาก", color: "#039be5" };
      case 2:
        return { label: "ไถ่ถอน", color: "#D32F2F" };
      case 3:
        return { label: "พร้อมขาย", color: "#D32F2F" };
      case 4:
        return { label: "ขายแล้ว", color: "#D32F2F" };
      case 5:
        return { label: "ถูกยืม", color: "#D32F2F" };
      case 6:
        return { label: "คืนแล้ว", color: "#D32F2F" };
      case 7:
        return { label: "แก้ไขข้อมูลสินค้า", color: "#D32F2F" };
      case 8:
        return { label: "ปรับต้นทุน", color: "#D32F2F" };
      case 9:
        return { label: "ยกเลิกรายการ", color: "#D32F2F" };
      case 10:
        return { label: "หลุดจำนำ", color: "default" };
      default:
        return { label: "-", color: "" };
    }
  };

  const getOrderType = (order_type) => {
    switch (order_type) {
      case "Order_sells":
        return { label: "ขาย", color: "#D32F2F" };
      case "Order_items":
        return { label: "ซื้อ", color: "#2E7D32" };
      case "order_pawns":
        return { label: "ฝาก", color: "#039be5" };
      case "order_borrows":
        return { label: "ยืม/คืน", color: "#2E7D32" };
      default:
        return { label: "ไม่ทราบสถานะ", color: "default" };
    }
  };

  React.useEffect(() => {
    console.log("viewList", viewProduct);

    const product = viewProduct?.order.map((item, index) => {
      const total_price =
        ["Order_items", "order_pawns", "order_borrows", "Order_sells"]
          .map((key) => item?.[key]?.[0]?.Product?.total_price)
          .find((price) => price !== undefined) || 0;

      const product_type =
        ["Order_items", "order_pawns", "order_borrows", "Order_sells"]
          .map((key) => item?.[key]?.[0]?.Product?.product_type)
          .find((price) => price !== undefined) || "-";

      return {
        order: index + 1,
        order_code: item?.order_code,
        total_price: total_price,
        status: (
          <Chip
            label={getOrderStatus(item?.order_status).label}
            style={{
              width: "100px",
              backgroundColor: getOrderStatus(item?.order_status).color,
              color: "white",
            }}
          />
        ),
        product_type: (
          // <Chip
          //   label={product_type == "buy_product" ? "ซื้อ" : "ฝากขาย"}
          //   style={{
          //     width: "50px",
          //     backgroundColor: `${
          //       product_type == "buy_product" ? "#039be5" : "#D32F2F"
          //     }`,
          //     color: "white",
          //   }}
          // />
          <Typography>
            {getOrderType(item?.Order_items?.length > 0
              ? "Order_items"
              : item?.Order_sells?.length > 0
                ? "Order_sells"
                : item?.order_pawns?.length > 0
                  ? "order_pawns"
                  : item?.order_borrows?.length > 0
                    ? "order_borrows"
                    : "-").label}
          </Typography>
        ),
        created_at: moment(item.created_at).format(
          "DD/MM/YYYY\n เวลา HH:mm:ss น."
        ),
      };
    });
    setDataUseForTable(product);
    console.log("viewProductINModal", product);
  }, [viewProduct]);
  useEffect(() => {
    if (
      viewProduct &&
      viewProduct.picture &&
      Array.isArray(viewProduct.picture)
    ) {
      const productImageUrls = viewProduct.picture.map((img) => img);
      setInitialProductUrls(productImageUrls);
    }
  }, [viewProduct]);

  const renderFields = (fields, values) => {
    return fields.map((field, index) => (
      <React.Fragment key={index}>
        <Grid item xs={12} sm={2}>
          <Typography variant="subtitle1">{field.label}</Typography>
        </Grid>
        <Grid item xs={12} sm={10}>
          <Typography variant="body1">
            {field.name === "category_id"
              ? (() => {
                  const category = categoryOptions.find((category) => {
                    return category.id === values.category;
                  });
                  // console.log("found category", category);
                  return category?.label || "";
                })()
              : values[field.name]}
          </Typography>
        </Grid>
      </React.Fragment>
    ));
  };
  const columns = [
    { Header: "ลำดับ", accessor: "order" },
    { Header: "รหัสรายการ", accessor: "order_code" },
    { Header: "จำนวนเงิน", accessor: "total_price" },

    { Header: "สถานะ", accessor: "status" },
    { Header: "ประเภท", accessor: "product_type" },
    { Header: "วันที่บันทึก", accessor: "created_at" },
  ];
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      sx={{
        borderRadius: "8px",
      }}
    >
      <DialogTitle>
        <Typography variant="h4">รายละเอียดลูกค้า</Typography>
      </DialogTitle>
      <DialogContent sx={{ padding: 0 }}>
        <Grid container spacing={3} sx={{ padding: 3 }}>
          <Grid item xs={12}>
            <Typography sx={{ mb: 3 }} variant="h4">
              ข้อมูลลูกค้า
            </Typography>
            <Grid container spacing={2} sx={{ mb: 3 }}>
              {renderFields(customersFields, viewProduct || {})}
            </Grid>
            <Typography sx={{ mb: 3 }} variant="h4">
              ตารางกระบวนการ
            </Typography>
            <TableModal
              columns={columns}
              data={dataUseForTable ? dataUseForTable : []}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ p: 3 }}>
        <GradientButtonOutline
          variant="outlined"
          sx={{ mr: 1 }}
          onClick={onClose}
        >
          กลับ
        </GradientButtonOutline>
      </DialogActions>
    </Dialog>
  );
};

export default ModalView;
